import { Components, Theme } from '@mui/material/styles';

import { rootElement } from '../constants';

export const muiPopoverOverride: Components<Omit<Theme, 'components'>>['MuiPopover'] = {
  defaultProps: {
    container: rootElement
  }
};
